import React from 'react';
import { Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import ReplayIcon from '@mui/icons-material/Replay';
import useStyles from '../styles';
import paymentSuccessImg from "../../../assets/images/payment-success.svg";
import paymentErrorImg from "../../../assets/images/payment-failure.svg";

const StatusPopup = ({
    isOpen,
    onClose,
    status = 'success', // 'success' or 'error'
    onActionClick,
    actionText = status === 'success' ? 'Go to Home' : 'Retry Payment',
    title = status === 'success' ? 'Payment Successful!' : 'Payment Declined',
    message = status === 'success'
        ? 'Your child now has lifetime access to Sandbox'
        : 'Please retry to complete your child\'s Sandbox Premium access.'
}) => {
    const classes = useStyles();

    if (!isOpen) return null;

    return (
        <div className={classes.statusPopupOverlay} onClick={onClose}>
            <div className={classes.statusPopupContainer} onClick={(e) => e.stopPropagation()}>
                <IconButton className={classes.closeIconButton} onClick={onClose}>
                    <CloseIcon fontSize="small" />
                </IconButton>

                <div className={classes.statusIcon}>
                    {status === 'success' ? (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <img src={paymentSuccessImg} alt="payment success" style={{
                                width: '70px',
                                height: '70px',
                                objectFit: 'contain'

                            }} />
                        </div>
                    ) : (
                        <div style={{

                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <img src={paymentErrorImg} alt="payment error" style={{
                                width: '70px',
                                height: '70px',
                                objectFit: 'contain'

                            }} />
                            {/* <ErrorIcon style={{ fontSize: 36, color: '#F44336' }} /> */}
                        </div>
                    )}
                </div>

                <h2 className={classes.statusTitle}>{title}</h2>
                <p className={classes.statusMessage}>{message}</p>

                <Button
                    className={classes.actionButton}
                    variant="contained"
                    onClick={onActionClick}
                    endIcon={status !== 'success' ? <ReplayIcon style={{ transform: 'rotate(-50deg)' }} /> : null}
                >
                    {actionText}
                </Button>
            </div>
        </div>
    );
};

export default StatusPopup;